module.exports = __webpack_public_path__ + "img/jiangzhang.07431a01.png";